import { render, staticRenderFns } from "./IssueEndorsement.vue?vue&type=template&id=0a25bb8f"
import script from "./IssueEndorsement.vue?vue&type=script&lang=ts"
export * from "./IssueEndorsement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports